module.exports = __webpack_public_path__ + "static/media/default-user-image.c91cf3a5.webp";